module.exports = __webpack_public_path__ + "static/media/logo-reconciliaccion.54cf7be9.jpg";